import { AfterViewInit, Component, ElementRef, Input, signal, ViewChild } from '@angular/core';
import { ThemingDirective } from '@shared/directives/theming.directive';

@Component({
  selector: 'slotcom-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  standalone: true,
  imports: [ThemingDirective],
})
export class LoadingComponent implements AfterViewInit {
  @ViewChild('loadingContainer', { static: true }) loadingContainer: ElementRef;
  @Input() color: string = 'blue';
  @Input() align: string = '';
  @Input() marginTop: number = 0;
  @Input() marginBottom: number = 0;

  loaderAsset = signal(this.color === 'pink' ? 'loader-rosa' : 'loader-azul');

  ngAfterViewInit() {
    this.loadingContainer.nativeElement.style.marginTop = this.marginTop * 0.757 + 'em';
    this.loadingContainer.nativeElement.style.marginBottom = this.marginBottom * 0.757 + 'em';
  }
}
